import React from 'react';
import ReactDOM from 'react-dom';

import './static/css/reset.scss';

import App from './Components/App/App';

import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js